<app-modal-header
  [title]="title"
  (closeModal)="closeThisModal($event)"
></app-modal-header>

<!--<app-custom-pdf-viewer-->
<!--  [base64Src$]="base64$"-->
<!--  [filenameForDownload]="title"-->
<!--&gt;</app-custom-pdf-viewer>-->
<iframe
  [src]="base64 | safeResource"
  style="min-height: 100vh"
  width="100%"
></iframe>

